/* ============ Load more: walks Ghost's own pagination ============ */
(function () {
  var btn = $('#load-more-btn');
  var grid = $('#stories-grid');
  if (!btn || !grid) return;

  var label = btn.textContent;

  btn.addEventListener('click', function () {
    var link = document.querySelector('link[rel="next"]');
    if (!link) { btn.parentElement.remove(); return; }

    btn.disabled = true;
    btn.textContent = label + '…';

    fetch(link.href)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('.grid .card');
        var frag = document.createDocumentFragment();

        newCards.forEach(function (card) {
          frag.appendChild(document.importNode(card, true));
        });
        grid.appendChild(frag);

        if (window.rootedApplyTopicFilter) window.rootedApplyTopicFilter();
        rootedObserve(grid);

        var nextLink = doc.querySelector('link[rel="next"]');
        if (nextLink && nextLink.href) {
          link.href = nextLink.href;
          btn.disabled = false;
          btn.textContent = label;
        } else {
          btn.parentElement.remove();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
